<template>
  <div>
    <div class="blockHeader">
        <div class="redBlock"></div>
        <div class="headerText">压实质量</div>
    </div>
    <div class="comRollContent work-wrapper">
        <div class="comRollTitle">碾压遍数</div>
        <div class="comRollInfo">
            <rollingTimes :rnImageUrl="rnImageUrl" :rollingTimesData="rollingNumInfo" :activeIndex1Code="0" :workId="workId" :projectCheck="projectCheck"/>
        </div>
        <div class="comRollTitle_1">压实度</div>
        <div class="comRollInfo">
            <rollingIcv :icvImageUrl="icvImageUrl" :rollingIcvData="rollingIcvData" :activeIndex1Code="1" :joinTypeV="joinTypeV" :workId="workId" :projectCheck="projectCheck"/>
        </div>
    </div>
    <div class="blockHeader" v-if="workInfo.workType==3||workInfo.workType==4">
        <div class="redBlock"></div>
        <div class="headerText">摊铺质量</div>
    </div>
    <div class="comRollContent work-wrapper"  v-if="workInfo.workType==3||workInfo.workType==4">
        <div class="comRollTitle">摊铺温度</div>
        <div class="comRollInfo">
            <pavingTemperature :activeIndex2Code="0" :pavingQualityTemperatureData="pavingQualityTemperatureData" :workId="workId" :projectCheck="projectCheck"/>
        </div>
    </div>
  </div>
</template>

<script>
  import rollingTimes from '../part/workPanel/rollingTimes'
  import rollingIcv from '../part/workPanel/rollingIcv'
  import pavingTemperature from '../part/workPanel/pavingTemperature'
  export default {
    name      : 'app',
    data() {
      return {
          rollingNumInfo: {},
          rollingIcvData: {},
          pavingQualityTemperatureData: {},
          joinTypeV: 0,
          workId:0,
          rnImageUrl:'',
          icvImageUrl:'',
      }
    },
    props:{
        workInfo: {
            type: Object,
            default: function () {
                return {};
            },
        },
        projectCheck: {
            type: Boolean,
            default: function () {
                return false
            },
        },
    },
    watch: {
    },
    computed:{

    },
    created(){

    },
    mounted(){
        this.rollingNumInfo = this.workInfo.rollingNumInfo
        this.rollingIcvData = this.workInfo.icvInfo
        this.pavingQualityTemperatureData=this.workInfo.temperatureInfo
        this.workId=this.workInfo.id
        this.rollingNumInfo.workId=this.workId
        this.rollingIcvData.workId=this.workId
        this.rnImageUrl=this.workInfo.rnImageUrl
        this.icvImageUrl=this.workInfo.icvImageUrl
        if(this.workInfo.temperatureInfo != null){
            this.workInfo.temperatureInfo.dataList = this.workInfo.temperatureInfo.data
            this.pavingQualityTemperatureData = this.workInfo.temperatureInfo
            this.pavingQualityTemperatureData.workId =this.workId
        }
        console.log(this.workInfo,"workInfo")
    },
    methods: {
        
    },
    components:{
        rollingTimes,
        rollingIcv,
        pavingTemperature
    }
  }
</script>
<style lang="scss">
.day{
    .el-table__header-wrapper{
        height: 35px;
        // border:1px solid rgba(228, 231, 237, 1);
        .el-table__header{
            height: 35px !important;
            tr{
                th{
                    background-color: #EBEBEC !important;
                    color: #555555 !important;
                    font-size: 14px !important;
                    padding: 0 !important;
                    height: 35px !important;
                    font-weight: 400 !important;
                    text-align: center;
                }
            }
        }  
    }
    .el-table__body-wrapper{
        tr{
            td{
                text-align: center;
            }
        }
    }
}
    
</style>
<style lang="scss" scoped="">
    .blockHeader{
      width: 100%;
      height: 58px;
      position: relative;
      .redBlock{
          height: 18px;
          width: 4px;
          position: absolute;
          background-color: #E96B5A;
          top: 19px;
          left: 20px;
        }
        .headerText{
          height: 16px;
          line-height: 16px;
          color: #222222;
          display: inline-block;
          position: absolute;
          top: 21px;
          left: 34px;
          font-weight: 600;
        }
    }
    .listContain{
        width: 98.5%;
        margin: 0 auto;
    }
    .comRollContent{
        width: 98.5%;
        margin: 0 auto;
        .comRollTitle{
            width: 100%;
            height: 49px;
            background: #F1F1F5;
            border: 1px solid #E1E1E1;
            line-height: 49px;
            padding-left:21px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #555555;
        }
        .comRollTitle_1{
            width: 100%;
            height: 49px;
            background: #F1F1F5;
            border: 1px solid #E1E1E1;
            line-height: 49px;
            padding-left:21px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #555555;
            border-top: 0;
        }
        .comRollInfo{
            width: 100%;
            height: 520px;
            background: #FFFFFF;
            border-left: 1px solid #E1E1E1;
            border-right: 1px solid #E1E1E1;
            border-bottom: 1px solid #E1E1E1;
            padding-left: 20px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
</style>